import React from 'react';
import { gvaAddNewButton } from 'services/FeatureFlags';

const isGVAAddEnabled = gvaAddNewButton();

export const GroupedAccountListHeader = ({ accountGroupName }) => (
  <div className="grouped-account-list-header">
    <div className="account-type-info">
      <div className="account-type">{accountGroupName}</div>
     {!isGVAAddEnabled && <div className="right-header">Access</div>}
    </div>
  </div>
);
